import type { LoadCurrentItemMetadataPayload, LoadItemMetadataPayload, LoadItemMetadataResult, OpenItemByIdPayload, OpenItemPayload, SetItemPageItemPayload, StoreDoUploadPayload, UploadItemFilesPayload } from "@mimir/web/store/storePayloads";
import { getGlobalStore } from '@mimir/web/store/index';

export async function storeDispatchDoUpload(payload: StoreDoUploadPayload) {
  return await getGlobalStore().dispatch('doUpload', payload);
}

export async function storeDispatchOpenItem(payload: OpenItemPayload): Promise<void> {
  return await getGlobalStore().dispatch('openItem', payload);
}

export async function storeDispatchLoadItemMetadata(payload: LoadItemMetadataPayload): Promise<LoadItemMetadataResult | null> {
  return await getGlobalStore().dispatch('loadItemMetadata', payload);
}

export async function storeDispatchLoadCurrentItemMetadata(payload: LoadCurrentItemMetadataPayload): Promise<LoadItemMetadataResult | null> {
  return await getGlobalStore().dispatch('loadCurrentItemMetadata', payload);
}

export async function storeDispatchSetItemPageItem(payload: SetItemPageItemPayload): Promise<void> {
  return await getGlobalStore().dispatch('setItemPageItem', payload);
}

export async function storeDispatchOpenItemById(payload: OpenItemByIdPayload): Promise<void> {
  return await getGlobalStore().dispatch('openItemById', payload);
}

export async function storeDispatchUploadItemFiles(payload: UploadItemFilesPayload): Promise<void> {
  return await getGlobalStore().dispatch('uploadItemFiles', payload);
}

